import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PlanCard = ({ 
  title,
  price,
  period,
  features,
  isPopular,
  onSubscribe,
  disabled,
  buttonText = 'Subscribe Now'
}) => {
  return (
    <div className={`relative p-6 md:p-8 rounded-xl transition-smooth ${
      isPopular 
        ? 'bg-gradient-to-br from-primary/10 to-secondary/10 border-2 border-primary shadow-warm-lg' 
        : 'bg-card border border-border shadow-warm'
    }`}>
      {isPopular && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 bg-gradient-to-r from-primary to-secondary rounded-full">
          <span className="text-xs font-caption font-bold text-white">MOST POPULAR</span>
        </div>
      )}
      <div className="text-center mb-6 md:mb-8">
        <h3 className="text-xl md:text-2xl font-heading font-bold mb-2">{title}</h3>
        <div className="flex items-baseline justify-center gap-1 mb-2">
          <span className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-primary">₹{price}</span>
          <span className="text-sm md:text-base text-muted-foreground">/{period}</span>
        </div>
        <p className="text-xs md:text-sm text-muted-foreground">Billed monthly, cancel anytime</p>
      </div>
      <div className="space-y-3 md:space-y-4 mb-6 md:mb-8">
        {features?.map((feature, index) => (
          <div key={index} className="flex items-start gap-3">
            <div className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-success/10 flex items-center justify-center mt-0.5">
              <Icon name="Check" size={14} color="var(--color-success)" />
            </div>
            <div className="flex-1">
              <p className="text-sm md:text-base font-medium">{feature?.title}</p>
              {feature?.description && (
                <p className="text-xs md:text-sm text-muted-foreground mt-1">{feature?.description}</p>
              )}
            </div>
          </div>
        ))}
      </div>
      <Button
        variant={isPopular ? 'default' : 'outline'}
        fullWidth
        size="lg"
        onClick={onSubscribe}
        disabled={disabled}
        iconName="CreditCard"
        iconPosition="left"
      >
        {buttonText}
      </Button>
    </div>
  );
};

export default PlanCard;